// React
import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";

// Amplify
import { signOut } from "aws-amplify/auth";

// Material UI
import { Box, Stack } from "@mui/material";

// Components
import {
  AdminHome,
  ClinicManagement,
  UserManagement,
  NavigationDrawer,
  ClinicSettings,
  ClientManagement,
  ClientSettings,
  NavigationBar,
  DrawerHeader,
} from "../";
import MFA from "Components/MFA/MFA";
import PortalLoading from "Common/Components/PortalLoading";
import useEnforcedLanguage from "Common/Hooks/useEnforcedLanguage";
import { clearAppSessionStorage } from "Auth/authUtils";

// Styles
import { styles } from "./styles";
import { offWhite } from "Constants/ColourConstants";

const AdminPortal = () => {
  const isLanguageReady = useEnforcedLanguage("en", "Admin");
  const signInMFA = sessionStorage.getItem("adminMFA");
  const [openSignInMFA, setOpenSignInMFA] = useState(
    !signInMFA || signInMFA === "sent"
  );

  const navigate = useNavigate();

  if (!isLanguageReady) {
    return <PortalLoading />;
  }

  const handleMFASuccess = () => {
    setOpenSignInMFA(false);
    sessionStorage.setItem("adminMFA", "verified");
    navigate("/");
  };

  const handleMFACancel = async () => {
    await signOut();
    clearAppSessionStorage();
    window.location.reload();
  };

  return (
    <Box sx={styles.portalBox}>
      {openSignInMFA ? (
        <>
          <MFA
            isAdmin={true}
            open={openSignInMFA}
            onClose={handleMFACancel}
            onVerify={handleMFASuccess}
          />
        </>
      ) : (
        <Stack sx={{ width: "100%", background: offWhite }}>
          <NavigationBar />
          <Stack direction="row">
            <NavigationDrawer />
            <Box component="main" sx={styles.mainComponent}>
              <DrawerHeader />
              <Routes>
                <Route path="/" element={<AdminHome />} />
                <Route
                  path="/ClinicManagement"
                  element={<ClinicManagement />}
                />
                <Route path="/AddClinic" element={<ClinicSettings />} />
                <Route path="/EditClinic" element={<ClinicSettings />} />
                <Route
                  path="/ClientManagement"
                  element={<ClientManagement />}
                />
                <Route path="/AddClient" element={<ClientSettings />} />
                <Route path="/EditClient" element={<ClientSettings />} />
                <Route path="/UserManagement" element={<UserManagement />} />
              </Routes>
            </Box>
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default AdminPortal;
